// extracted by mini-css-extract-plugin
export default {"cls1":"VeloMenu-VeloMenuItem_cls1__VS35w","cls2":"VeloMenu-VeloMenuItem_cls2__N2N9j VeloMenu-VeloMenuItem_cls1__VS35w"};